import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { usePageMeta } from "@/hooks/usePageMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import PicksSection from "@/pages/home/components/PicksSection";
import TopRatedSection from "@/pages/home/components/TopRatedSection";
import FavoritesSection from "@/pages/home/components/FavoritesSection";
import IntroSection from "@/pages/home/components/IntroSection";

export default function Home() {
  usePageMeta({
    title: "韩国伦理电影在线观看 - 最新韩国伦理电影在线观看平台",
    description:
      "韩国伦理电影在线观看提供丰富的韩国伦理电影资源，涵盖不同类型的伦理影片，方便用户在线观看最新影视内容，体验高质量观影体验。",
    keywords:
      "韩国伦理电影在线观看,韩国伦理电影,伦理电影在线观看,韩国电影观看,影视视频在线观看",
  });

  return (
    <Layout>
      <HeroCarousel />
      <CategoryEntries />
      <PicksSection />
      <TopRatedSection />
      <FavoritesSection />
      <IntroSection />

      <section className="px-4 md:px-8 lg:px-12 pb-16 md:pb-24">
        <div className="max-w-shell mx-auto relative rounded-lg overflow-hidden border border-background-200/70">
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20quiet%20empty%20Korean%20cinema%20lobby%20at%20night%2C%20warm%20amber%20poster%20light%20boxes%20glowing%20on%20charcoal%20walls%2C%20polished%20dark%20floor%20reflections%2C%20atmospheric%20film%20grain%2C%20no%20text%2C%20no%20people&width=1600&height=700&seq=home-cta-2026&orientation=landscape"
            alt="电影放映厅氛围"
            title="韩国伦理电影在线观看 - 今晚挑一部电影"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/85 to-background-50/30"></div>
          <div className="relative px-5 md:px-10 py-10 md:py-14 max-w-2xl">
            <p className="font-label text-[11px] tracking-[0.32em] text-primary-500 mb-3">NIGHT SCREENING</p>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 font-semibold leading-snug">
              今晚，挑一部安静的电影
            </h2>
            <p className="mt-3 text-sm md:text-[15px] text-foreground-700 leading-relaxed">
              从 40 部韩国伦理电影中按心情选择。喜欢细腻的家庭叙事，可以从剧情伦理开始；
              想看克制的爱情故事，就到爱情伦理分类里翻一翻。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category/all"
                className="h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium flex items-center gap-2 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                浏览全部片库
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <Link
                to="/search"
                className="h-10 px-5 rounded-md border border-background-300 text-foreground-800 text-sm flex items-center gap-2 hover:border-primary-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-search-line" aria-hidden="true"></i>
                直接搜索片名
              </Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}